/**
 * * Модель удаления шаблона
 */
export default class RemoveTemplateRequest  {
	/**
	 * * Номер шаблона
	 */
	TemplateId!: string;
	constructor(obj?: Partial<RemoveTemplateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
